import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { initTheme } from "@/settings/theme";
import { initAccessibilityFolaPrefs } from "@/settings/accessibility.js";
import { installChunkRecovery } from "@/lib/chunkRecovery.js";
initTheme();
initAccessibilityFolaPrefs();

import "@/styles/afrimed.css";             // SSOT (tokens/utilities/buttons)
import "@/sot/afrimed-design-system.css";  // DS (patterns)
import "@/styles/index.css";              // your tailwind layers (if any)

import App from "./App";

installChunkRecovery();

ReactDOM.createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>
);
